import { render } from "./CardEska.vue?vue&type=template&id=80ece57a&scoped=true"
import script from "./CardEska.vue?vue&type=script&lang=js"
export * from "./CardEska.vue?vue&type=script&lang=js"

import "./CardEska.vue?vue&type=style&index=0&id=80ece57a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80ece57a"]])

export default __exports__